import React from "react";
import "./index.scss"
import Title from "features/components/title";
import {object, oneOfType, string} from "prop-types";

const PaymentInfoBox = (props) => {
    const {price, title, children} = props;
    return <div className="payment-info-box">
        <div className="row">
            <Title size={16}>{title}</Title>
            <Title size={24}>€ {price}</Title>
        </div>
        {children}
    </div>
};

PaymentInfoBox.propTypes = {
    title: oneOfType([string, object]).isRequired,
    price: oneOfType([string, object]).isRequired
};

export default PaymentInfoBox;